export default angular
  .module("GenerateTestsCtrl", ["ui.bootstrap"])
  .controller("GenerateTestsController", [
    "$scope",
    "$modalInstance",
    "Scripts",
    function ($scope, $modalInstance, Scripts) {
      $scope.data = undefined;
      $scope.status = {
        isCompiling: false,
        time: 0,
        progress: 0,
        lastCompilationTime: null,
        error: null,
      };

      $scope.compile = () => {
        Scripts.getReminderTestCollection((data) => {
          $scope.data = `data:text/json;charset=utf-8, ${JSON.stringify(data)}`;
        });
      };

      $scope.ok = () => {
        $modalInstance.close();
      };
    },
  ]);
